export const selectNotifications = state => state.newNotifications;
